import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { LangLoader } from '@i18n/lang-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsModule } from '@ngxs/store';
import firebase from 'firebase/app';
import { RESTClientModule, RESTClientConfig } from 'rest-client';

import { APIConfigFactory } from '@core/utils/rest-client.config';
import { environment } from '@env/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './modules/core/core.module';
import { ErrorHandlerModule } from './modules/core/errors/error-handler.module';
import { SharedModule } from './modules/shared/shared.module';
import { BookingMainPageComponent } from './pages/booking-main-page/booking-main-page.component';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';
// eslint-disable-next-line import/no-unassigned-import
import 'firebase/auth';

firebase.initializeApp(environment.firebaseConfig);

const ANGULAR_MODULES = [
  CoreModule,
  SharedModule,
  BrowserAnimationsModule,
  BrowserModule,
  ErrorHandlerModule,
];
const PUBLIC_COMPONENTS = [
  AppComponent,
  NotFoundPageComponent,
  BookingMainPageComponent,
];

@NgModule({
  declarations: [...PUBLIC_COMPONENTS],
  imports: [
    ...ANGULAR_MODULES,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: LangLoader,
      },
    }),
    RESTClientModule,
    NgxsModule.forRoot([], { developmentMode: !environment.production }),
    NgxsReduxDevtoolsPluginModule.forRoot({ disabled: environment.production }),
  ],
  providers: [
    {
      provide: RESTClientConfig,
      useFactory: APIConfigFactory,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
